/**
 * Semantic color palette — sourced verbatim from DESIGN.md.
 * These are OPERATIONAL colors, not decorative. Do not re-use tokens for
 * purposes other than the ones documented below.
 */
export const colors = {
  // Surfaces
  canvas: "#f4efe6",
  shell: "#ede7db",
  panel: "#fffdf8",
  panelMuted: "#e4dccd",
  line: "#cfc3ae",

  // Text
  text: "#1d2a21",
  textMuted: "#5f675d",

  // Primary — confirmation, advance
  primary: "#2f6b3d",
  onPrimary: "#ffffff",

  // Intelligence — suggestions, memory prefill, auto-detected
  intelligence: "#0066ff",
  onIntelligence: "#ffffff",

  // Manual geometry — operator-drawn boxes
  manual: "#ff7f0e",
  onManual: "#1f1305",

  // Warning — editorial exceptions (SKU não encontrado)
  warning: "#d97706",
  onWarning: "#ffffff",

  // Danger — conflicts, removals
  danger: "#dc2626",
  onDanger: "#ffffff",

  // Neutral — trash, secondary controls
  neutral: "#6b7280",
  onNeutral: "#ffffff",

  // Overlap comparison (B side)
  overlapB: "#06b6d4",
} as const;

export type ColorToken = keyof typeof colors;

/**
 * Object-status → color mapping per DESIGN.md §3.
 */
export const objectStatusColor = {
  suggested: colors.intelligence,
  confirmed: colors.primary,
  manual: colors.manual,
  exception: colors.warning,
  trash: colors.neutral,
} as const;

/**
 * Stage names — authoritative Portuguese labels. Mirrors marcador's
 * `WORKFLOW_STAGE_LABELS` plus DESIGN.md's 3B and 5B stages.
 */
export const STAGES = [
  { id: "1", label: "Triagem por Página" },
  { id: "2", label: "Resolver Sobreposições" },
  { id: "3", label: "Ajustes Manuais" },
  { id: "3B", label: "Recuperar Trash" },
  { id: "4", label: "Conferência Final" },
  { id: "5", label: "Classificação" },
  { id: "5B", label: "Controle Sem Marca" },
] as const;

export type StageId = (typeof STAGES)[number]["id"];

/**
 * Cycle status code → human-readable Portuguese label. Status codes are
 * the wire/storage form (CycleStatus enum); these are what operators read.
 */
export const CYCLE_STATUS_LABEL: Record<string, string> = {
  QUEUED: "Na fila",
  PROCESSING: "Processando",
  READY_FOR_REVIEW: "Pronto",
  IN_REVIEW: "Em revisão",
  COMPLETED: "Concluído",
  FAILED: "Falhou",
};

export function cycleStatusLabel(code: string): string {
  return CYCLE_STATUS_LABEL[code] ?? code;
}
